import * as React from 'react';
import swal from 'sweetalert';
import Table from '@mui/material/Table';
import Paper from '@mui/material/Paper';
import { useDispatch } from "react-redux";
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import DoneIcon from '@mui/icons-material/Done';
import TuneIcon from '@mui/icons-material/Tune';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@mui/material';
import { approvePermissionChangeRequest, rejectPermissionChangeRequest } from '../api/elevationapi';

const columns = [
  { id: 'email', label: 'Email Address' },
  { id: 'current_role', label: 'Current Role' },
  { id: 'current_permission', label: 'Current Permissions' },
  { id: 'requested_permission', label: 'Requested Permissions' },
  { id: 'message', label: 'Message' , maxWidth: 150},
  { id: 'status', label: 'Status' },
  { id: 'actions', label: 'Actions'}
];

export default function PermissionsChangeRequestList({
  rowsPerPage,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
  requestList,
  handlePermissionDialogOpen
}) {

  const dispatch = useDispatch();

  const handleReject = (requestId) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to Ignore this Request!",
      icon: "warning",
      buttons: ["Cancel", "OK"],
    })
    .then(willReject => {
      if (willReject) {
        dispatch(rejectPermissionChangeRequest(requestId,page));
      }
    });
  };

  const handleAccept = (requestId,userId) => {
    let data = {
      'requestId' : requestId,
      'userId' : userId,
    }
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to Approve this Request!",
      icon: "warning",
      buttons: ["Cancel", "OK"],
    })
    .then(willAccept => {
      if (willAccept) {
        dispatch(approvePermissionChangeRequest(data,page));
      }
    });
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  //style={{ minWidth: column.minWidth ,maxWidth: column.maxWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {requestList?.records?.length > 0 ? requestList?.records.map((row,i) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                        <TableCell 
                          key={column.id} 
                          align={column.align}
                          style={{ wordBreak: 'break-all', maxWidth: column.maxWidth }}
                        >
                            {column.format && typeof value === 'number'
                            ? column.format(value) 
                            : column.id === 'status' ? 
                              row.status === 0 ?   <Button className='pendingButton' variant="contained" size="small">Pending</Button> 
                              : row.status === 1  ?  <Button className='approveButton' variant="contained" size="small">Approved</Button> : <Button className='ignoreButton' variant="contained" size="small">Ignored</Button>
                            : column.id === 'current_permission' ? 
                              <IconButton 
                                className='requestIcons'
                                onClick={(e) => handlePermissionDialogOpen(row.id,'current')}
                              >
                                <TuneIcon />
                              </IconButton>
                            : column.id === 'requested_permission' ? 
                            <IconButton 
                              className='requestIcons'
                              onClick={(e) => handlePermissionDialogOpen(row.id,'request')}
                            >
                              <TuneIcon />
                            </IconButton>
                            
                            : column.id === 'actions' ? 
                              row.status === 0 ?
                                <>
                                  <IconButton onClick={(e) => handleAccept(row.id,row.user_id)}>
                                    <DoneIcon color="primary" />
                                  </IconButton>
                                  <IconButton onClick={(e) => handleReject(row.id)}>
                                    <CloseIcon color="error" />
                                  </IconButton>
                                </>
                              : ''
                            : value 
                            }
                        </TableCell>
                    );
                  })}
                </TableRow>
              );
            }) : <TableRow><TableCell colSpan={3}>No Data Available. </TableCell></TableRow>}
          </TableBody>
        </Table>
      </TableContainer>
      {requestList?.total > 0 ?
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={requestList?.total}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage} />
        : <></>}
    </Paper>  
  );
}

